import { makeAutoObservable, toJS } from 'mobx'

import findTicketStore from 'entities/beket/models/find-ticket/find-ticket-store.ts'

import {
  BeketPaginationPage,
  BeketTicket,
  BeketTicketDetail,
  SearchApiBeket,
} from 'shared/api/beket/search'

import { BeketFindTicketForm } from '../../find-ticket/model'

const ITEM_PAGE = 25

class BeketListTicketsStore {
  listOfTickets: BeketTicket[] | [] = []
  selectedTicket: BeketTicketDetail | null = null
  abortController: AbortController | null = null
  loading: boolean = false
  maxPage: number = 1
  page: number = 1
  searchKey: string | undefined = undefined

  constructor() {
    makeAutoObservable(this)
  }

  async onGetTicketRequest(findForm: BeketFindTicketForm) {
    const requestData = findForm
    const direction = requestData?.directions[0]

    if (!requestData) return

    const queryParams: Partial<BeketPaginationPage> = {
      arrival_city: direction?.to?.id,
      departure_city: direction?.from?.id,
      departure_date: direction?.date,
      adult: requestData?.adult,
      child: requestData?.child,
      page: this.page,
      per_page: ITEM_PAGE,
    }

    if (this.loading && !queryParams) return

    try {
      if (queryParams.page === 1) {
        this.abortController = new AbortController()
      }

      this.loading = true
      const { data: ticketsData } = await SearchApiBeket.searchTicket(
        queryParams as BeketPaginationPage,
        this.abortController?.signal,
      )

      this.loading = false
      this.maxPage = ticketsData?.total_pages || 1
      this.page = this.page + 1
      this.searchKey = ticketsData.searchkey

      this.setListOfTicket(ticketsData?.data)
    } catch (err) {
      this.loading = false
    }
  }

  setListOfTicket(tickets: BeketTicket[]) {
    this.listOfTickets = [...(this.listOfTickets || []), ...tickets]
  }

  setDetailTicket(ticket: BeketTicketDetail) {
    this.selectedTicket = ticket
  }

  getListTickets() {
    return this.listOfTickets
  }

  onNewListOfTicket() {
    const requestData = toJS(findTicketStore.formFindTicket)

    this.resetListOfTicket()
    this.onGetTicketRequest(requestData)
  }

  resetListOfTicket() {
    this.listOfTickets = []
    this.selectedTicket = null
    this.page = 1
    this.maxPage = 1
    this.loading = false

    if (this.abortController) {
      this.abortController.abort()
    }
  }
}

export default new BeketListTicketsStore()
